import { render, staticRenderFns } from "./BackofficeInformacoesSobreOrcamento.vue?vue&type=template&id=181cb438"
import script from "./BackofficeInformacoesSobreOrcamento.vue?vue&type=script&lang=ts"
export * from "./BackofficeInformacoesSobreOrcamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports